import React from 'react';

// Active location context (Phase B4 stub).
//
// The seed bug from REFACTOR-PLAN §1.6 is "Tasks read a different
// location than the user is actually working at." The fix (Phase E,
// task E2) will introduce a server-side activeLocationFor() resolver
// and feed its output into this context. For now this context exposes
// the same `location` state the App root has always managed — so
// consumers migrating off props don't change behavior.
//
// Shape:
//   {
//     active: <location row { id, name, ... } | null>,
//     override: null,           // E2 will set this when the location
//                               //   switcher fires
//   }

const LocationContext = React.createContext({ active: null, override: null });

export { LocationContext };
export default LocationContext;
